export default {
  title: 'Terminal',
  stats: {
    terminal_battery_level: 'Poziom baterii',
    terminal_battery_state: 'Stan ładowania',
    auto_accept_orders: 'Automatycznie akceptuj zamówienia',
  },
  auto_accept_orders_modal: {
    title: 'Czy na pewno chcesz automatycznie akceptować zamówienia?',
    buttons: {
      activate: 'Aktywuj',
      cancel: 'Anuluj',
    },
  },
  feedback: {
    update_success: 'Zaktualizowano pomyślnie',
    update_failed: 'Nie udało się zaktualizować informacji. Spróbuj ponownie.',
  },
};
